// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__aYZY7","insightsList":"newBusinessInsightsMenu_insightsList__gQqIp","active":"newBusinessInsightsMenu_active__2JuTw"};